"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CartClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CartClient = exports.CartClient = {
  createCart: function createCart(itineraryId, isV1, headers) {
    if (headers === void 0) {
      headers = {};
    }
    var requestId = 'CREATE_FLIGHT_CART';
    var endPointConstant = isV1 ? _constants.ENDPOINTS.CREATE_CART_V1 : _constants.ENDPOINTS.CREATE_CART;
    var endPoint = endPointConstant.replace('{itineraryId}', itineraryId);
    var config = {
      headers: _objectSpread({
        'x-pricing-version': 1
      }, headers)
    };
    return _http.$http.get(requestId, endPoint, config).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  getCart: function getCart(cartId, searchParams) {
    if (searchParams === void 0) {
      searchParams = '';
    }
    var requestId = 'GET_FLIGHT_CART_V3';
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_CART, {
      cartId: cartId
    });
    var config = {
      headers: {
        'Cache-Control': 'private, no-cache, no-store, must-revalidate',
        Expires: '-1',
        Pragma: 'no-cache',
        'x-pricing-version': 1
      }
    };
    return _http.$http.get(requestId, endPoint + searchParams, config).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  sellSeat: function sellSeat(payload, isV3) {
    var requestId = 'SEAT_RESERVATION_FLIGHT_CART';
    var endPoint = isV3 ? _constants.ENDPOINTS.SEAT_RESERVATION_V3 : _constants.ENDPOINTS.SEAT_RESERVATION;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref3) {
      var data = _ref3.data;
      return data;
    });
  },
  updateSSR: function updateSSR(payload) {
    var requestId = 'SSR_UPDATE_FLIGHT_CART';
    return _http.$http.put(requestId, _constants.ENDPOINTS.UPDATE_SSR_V3, {
      data: payload
    }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  updateMultiSSR: function updateMultiSSR(payload) {
    var requestId = 'MULTI_SSR_UPDATE_FLIGHT_CART';
    var cartId = payload.cartId;
    return _http.$http.put(requestId, (0, _client.replaceParams)(_constants.ENDPOINTS.MULTI_SSR_V3_UPDATE, {
      cartId: cartId
    }), {
      data: payload
    }).then(function (_ref5) {
      var data = _ref5.data;
      return data;
    });
  },
  updateAddOns: function updateAddOns(cartId, addOns) {
    if (addOns === void 0) {
      addOns = [];
    }
    var requestId = 'ADDON_FLIGHT_CART';
    var endPoint = _constants.ENDPOINTS.ADDON;
    return _http.$http.post(requestId, endPoint, {
      data: {
        cartId: cartId,
        addOn: addOns
      }
    }).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  }
};